import { render, staticRenderFns } from "./VerificationsList.vue?vue&type=template&id=9b7ea344&scoped=true&"
import script from "./VerificationsList.vue?vue&type=script&lang=js&"
export * from "./VerificationsList.vue?vue&type=script&lang=js&"
import style0 from "./VerificationsList.vue?vue&type=style&index=0&id=9b7ea344&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b7ea344",
  null
  
)

export default component.exports